import CustomElement from '~utilities/custom-element';

const [_BTN_START, _BTN_BACK, _BTN_RESET, __BTN_NEXT] = [
	'[js-button-start]',
	'[js-button-back]',
	'[js-button-reset]',
	'[js-button-next]',
];

const [_V_INTRO, _V_SURVEY, _V_RESULT] = [
	'[js-view-intro]',
	'[js-view-survey]',
	'[js-view-result]',
];

const [_C_PROGRESS, _C_INDICATOR] = [
	'[js-progress-bar]',
	'[js-progress-indicator]',
];

const [_C_NAV] = ['[js-nav]'];

const _I_IMG_HOLDER = '[js-image-holder]';

class Survey extends CustomElement {
	constructor() {
		super();
		// console.log('done');
	}

	connectedCallback() {
		super.callback();
		// console.log('callback');
		this.progress = -1;
		this.displayResult = false;
		this.results = [];
		this.answered = [];
		this.ended = false;
		this.numQuestions = this.element.querySelectorAll(
			`[js-questionblock]`
		).length;

		this.headertitle = document.querySelector('.image__header');
		this.video = document.querySelector('.lottie__player');

		console.log('video?', this.video)
		this.scrollContainer = document.querySelector('.content--scroll');
		this.nav = this.element.querySelector(_C_NAV);

		document.getElementById('qs').innerHTML = this.numQuestions;





		// console.log('--->', this.video);

		this.btn = {
			start: this.element.querySelector(_BTN_START),
			back: this.element.querySelector(_BTN_BACK),
			reset: this.element.querySelector(_BTN_RESET),
			next: this.element.querySelector(__BTN_NEXT),
			radios: this.element.querySelectorAll(`[js-radio]`),
		};

		this.attachClickHandlers();
		this.attachViews();

		this.initProgress();
	}

	initProgress() {
		this.cIndicator.innerHTML = `vraag 1 van de ${this.numQuestions}&nbsp;`;
		this.cProgress.value = 0;
		this.cProgress.setAttribute('max', this.numQuestions);
	}

	updateProgress() {
		console.log('progress : ', this.progress);
		this.cIndicator.innerHTML = `vraag ${this.progress + 1} van de ${this.numQuestions}&nbsp;`;
		this.cProgress.value = this.progress + 1;

		const focusEl = document.querySelector(`[js-answer-parent-id="${this.progress}"]`)

		console.log('focus element: ', focusEl)

		focusEl.focus()


	}

	attachClickHandlers() {
		this.btn.start.addEventListener('click', () => this.startSurvey());

		this.btn.radios.forEach((e) => {
			e.addEventListener('click', this.displayAnswer.bind(this));
		});

		this.btn.radios.forEach((e) => {
			e.addEventListener('keyup', this.displayAnswer.bind(this));
		});

		this.btn.next.addEventListener('click', () => {
			this.nextStep();
		});

		this.btn.back.addEventListener('click', () => {
			this.previousStep();
		});
	}

	attachViews() {
		this.vIntro = this.element.querySelector(_V_INTRO);
		this.vSurvey = this.element.querySelector(_V_SURVEY);
		this.vResult = this.element.querySelector(_V_RESULT);

		this.cProgress = this.element.querySelector(_C_PROGRESS);
		this.cIndicator = this.element.querySelector(_C_INDICATOR);

		this.imageContainer = document.querySelector('.header__image');

		this.share = this.element.querySelector('[js-share]');


		this.imageForegroundContainer = document.querySelector(
			'.image__foreground'
		);

		console.log('attach image', this.imageContainer);
		console.log('---------->', this.imageForegroundContainer);
	}

	toggleAnswerContent(id, state) {
		const els = this.element.querySelectorAll(`[js-answer-parent-id="${id}"]`);
		els.forEach((el) => {
			state ? el.classList.add('hidden') : el.classList.remove('hidden');
		});
		
		const question = this.element.querySelector(`[js-questionblock="${id}"]`);
		question.classList[state ? 'add' : 'remove']('is--hidden');
	}

	// toggle answer
	toggleAnswer(id, display) {
		// console.log('display answer : ', id, display);
		const answer = this.element.querySelector(
			`[js-question-block-answer-id="${id}"]`
		);

		if (!answer) return this.resetToHome();

		display
			? answer.classList.remove('hidden')
			: answer.classList.add('hidden');
	}

	resetToHome() {
		// console.log('reset');
		this.vIntro.classList.remove('hidden');
		this.vSurvey.classList.add('hidden');
		// this.headertitle.style.display = 'block';
		this.video.style.display = 'block';

		this.scrollContainer.classList.remove('reverse');
	}

	toggleValid(id, isAnswer, state) {
		console.log('toggleValid', id, isAnswer, state)
		const el = this.element.querySelector(
			`[js-result-text="${id}"][${isAnswer == 1 ? 'js-correct' : 'js-incorrect'
			}]`
		);

		console.log('element', el)

		// console.log(
		// 	'state',
		// 	state,
		// 	this.element.querySelectorAll(`[js-result-text="${id}"]`)
		// );

		state
			? el.classList.remove('hidden')
			: this.element
				.querySelectorAll(`[js-result-text="${id}"]`)
				.forEach((el) => el.classList.add('hidden'));
	}

	toggleNext(state) {
		if (this.progress + 1 === this.numQuestions) {
			this.btn.next.innerHTML =
				'<i class="fas fa-arrow-circle-right"></i><span class="button--text">Toon uitslag</span>';
		} else {
			this.btn.next.innerHTML =
				'<i class="fas fa-arrow-circle-right"></i><span class="button--text">Verder</span>';
		}
		this.updateProgress();

		state
			? this.btn.next.classList.remove('hidden')
			: this.btn.next.classList.add('hidden');

		state
			? this.nav.classList.remove('hidden')
			: this.nav.classList.add('hidden')
	}

	toggleExplanation(id, state) {
		const resultId = this.element.querySelector(
			`[js-answer-result-id="${id}"]`
		);
		state
			? resultId.classList.remove('hidden')
			: this.element
				.querySelectorAll('[js-answer-result-id]')
				.forEach((el) => el.classList.add('hidden'));
	}

	hideBlock(id) {
		const questionBlock = this.element.querySelector(
			`[js-questionblock="${id}"]`
		);
		questionBlock.classList.add('hidden');
	}

	startSurvey() {
		console.log('start surv');
		// this.scrollContainer.classList.add('reverse');

		console.log('------>', document.getElementsByClassName("lottie_control"))
		document.getElementsByClassName("lottie_control")[0].style.display = "none"

		this.scrollContainer.classList.add('reverse');

		this.vIntro.classList.add('hidden');
		this.vSurvey.classList.remove('hidden');
		this.nextStep();


		try {

			this.imageContainer.src = '';
			this.imageForegroundContainer.src = '';

			this.headertitle.style.display = 'none';
			this.video.style.display = 'none';
		} catch (e) {
			console.log('not implemented yet');
		}


		// scroll content to bottom

	}

	// display answer after clicking radio select box
	displayAnswer(e) {

		console.log('this should not be a click', e.target.checked);

		if (e.code == "Space") {
			console.log("space")
			return;
		}

		const radio = e.target;

		if (
			!(e.key == "Enter" && e.target.checked
				|| e.target.checked && !document.documentElement.classList.contains('has--keyboard-focus'))
		) return;



		const selected = e.target;
		this.displayResult = true;

		const parentId = parseInt(selected.getAttribute('js-answer-parent-id'));
		const isAnswer = selected.getAttribute('js-is-answer');
		const explanationId = selected.getAttribute('js-answer-explanation-id');
		const weight = selected.getAttribute('js-weight');

		console.log(parentId);
		console.log(weight);
		console.log('is-answer', isAnswer);

		// console.log('display answer : ', parentId);

		this.showAnswer(parentId, isAnswer, explanationId);
	}

	displayQuestionBlock(id, state) {
		const questionBlock = this.element.querySelector(
			`[js-questionblock="${id}"]`
		);

		console.log(id, state)

		const inp = questionBlock.querySelectorAll('.form__item-radio')[0];
		// console.log('focus: ', inp);
		// inp.focus();


		const img = questionBlock.querySelector('[js-image-holder]');
		const img_foreground = questionBlock.querySelector('[js-image-foreground]');
		console.log('-->', this.imageContainer, img_foreground);


		// disabled, not needed in this project
		// this.imageContainer.src = img.src;

		try {
			if (img_foreground.src) {
				this.imageForegroundContainer.src = img_foreground.src;
				this.imageForegroundContainer.alt = img_foreground.alt;
			}
			console.log('img', img_foreground)
			document.getElementsByClassName('foreground__container')[0].style.display = 'block';
			document.getElementsByClassName('header__title')[0].style.display = 'none';
		} catch (e) {
			this.imageForegroundContainer.src = '';
			document.getElementsByClassName('foreground__container')[0].style.display = 'none';
			document.getElementsByClassName('header__title')[0].style.display = 'block';
		}

		// console.log('--> ? ', img);

		state
			? questionBlock.classList.remove('hidden')
			: questionBlock.classList.add('hidden');
	}

	changeImage(el) {
		// console.log('---->', el);
		el.querySelector(`${_I_IMG_HOLDER}`);

		this.imageContainer = el.querySelector(`${_I_IMG_HOLDER}`);
	}

	showAnswer(parentId, isAnswer, explanationId) {
		// console.log('showAnswer', parentId, isAnswer, explanationId);
		this.toggleAnswerContent(parentId, true);
		this.toggleAnswer(parentId, true);
		this.toggleExplanation(explanationId, true);
		this.toggleNext(true);
		this.toggleValid(parentId, isAnswer, true);
		this.displayQuestionBlock(parentId, true);

		this.results[parentId] = parseInt(isAnswer);
		this.answered[parentId] = parseInt(explanationId);
	}

	// displays options
	nextStep() {
		// console.log('display options', this.progress);

		if (this.numQuestions - 1 === this.progress) return this.endSurvey();

		this.progress++;

		this.displayQuestionBlock(this.progress, true);
		this.hidePreviousStep(this.progress);
		this.toggleNext(false);
		this.displayResult = false;


		const container = document.getElementsByClassName('content--scroll')[0];
		container.scrollTop = -10000;

		// console.log(container);
	}

	previousStep() {
		// this.progress--;
		this.vResult.classList.add('hidden');
		// console.log(
		// 	'previous step',
		// 	this.progress,
		// 	this.displayResult,
		// 	this.results
		// );

		if (this.ended) return this.returnFromEnd();

		if (this.displayResult) {
			if (this.progress < 0) this.resetToHome();
			// console.log('display options back from result');
			this.displayResult = false;
			this.toggleAnswerContent(this.progress, false);
			this.toggleAnswer(this.progress, false);
			this.toggleExplanation(this.progress, false);
			this.toggleValid(this.progress, null, false);
			this.toggleNext(false);

			this.answered.pop();
			this.results.pop();
		} else {
			this.displayResult = true;

			// console.log('display answer from next options');
			// console.log('current id : ', this.progress);

			// remove header & questions
			this.toggleAnswer(this.progress, false);
			this.toggleAnswerContent(this.progress, false);
			this.hideBlock(this.progress);

			this.progress--;

			// console.log(this.progress, this.answered, this.results);

			if (this.progress < 0) return this.resetToHome();

			this.showAnswer(
				this.progress,
				this.results[this.results.length - 1],
				this.answered[this.answered.length - 1]
			);
		}
	}

	returnFromEnd() {
		// console.log('display last result', this.progress);
		this.ended = false;
		this.vResult.classList.add('hidden');
		this.progress--;
		this.displayResult = true;

		this.showAnswer(
			this.progress,
			this.results[this.results.length - 1],
			this.answered[this.answered.length - 1]
		);

		// this.toggleAnswer(this.progress - 1, true);
		// this.toggleAnswerContent(this.progress - 1, true);
		// this.hideBlock(this.progress);
	}

	hidePreviousStep(id) {
		const questionBlock = this.element.querySelector(
			`[js-questionblock="${parseInt(id - 1)}"]`
		);

		if (!questionBlock) return false;

		questionBlock.classList.add('hidden');
	}

	setImage() { }

	endSurvey() {
		// console.log('this is the end of the survey');
		this.ended = true;
		this.displayQuestionBlock(this.progress, false);
		this.toggleNext(false);
		this.vResult.classList.remove('hidden');
		this.displayResult = false;
		this.progress++;
		// this.imageForegroundContainer.src = '';
		// console.log(this.results);
		// console.log(this.progress);

		const checkContainer = this.element.querySelector(`[js-checks]`);
		const totalCorrect = this.element.querySelector(`[js-total-correct]`);
		const totalQuestions = this.element.querySelector(`[js-total-questions]`);
		const totalQuestionsAmount = this.numQuestions;
		const total = this.element.querySelector(`[js-total]`);


		const totalAmount = this.results.reduce((a, c) => a + c)
		console.log(totalAmount, totalQuestionsAmount, totalAmount / totalQuestionsAmount)
		const score = totalAmount / totalQuestionsAmount

		totalQuestions.innerHTML = totalQuestionsAmount
		totalCorrect.innerHTML = totalAmount;
		// total.innerHTML = this.results.length;


		const resultTexts = [
			'Dat is een fantastische score. Een Whatsapp oplichter zal aan jou geen cent meer verdienen. Goed gedaan!',
			'Dat is een prima score. Op een aantal punten zagen we nog ruimte voor verbetering maar dat zal na het spelen van deze test zeker goed komen!',
			'We zien ruimte voor verbetering. We hopen dat je veel geleerd hebt van deze test en in de toekomst beter beschermd bent tegen internetfraude.'
		];

		let resultText = resultTexts[2];

		if (score > 0.6) resultText = resultTexts[1];
		if (score == 1) resultText = resultTexts[0];

		// console.log('-=->',this.share.href);


		this.share.href = `https://api.whatsapp.com/send?text=Ik heb ${totalAmount} punten gehaald bij het spelen van de fraude test. Speel ook deze test om er achter te komen hoe goed jij beschermd bent tegen oplichters. https://bit.ly/45ZYoMu`;


		this.element.querySelector('.result__explanation').innerHTML = resultText;

		checkContainer.innerHTML = '';

		this.results.forEach((result) => {
			if (result) {
				console.log('goed');
				checkContainer.innerHTML += '	<i class="fas fa-check check-good"></i>';
			} else {
				console.log('fout');
				checkContainer.innerHTML += '	<i class="fas fa-times check-fault"></i>';
			}
		});
	}

	back() { }
}

export default Survey;
